import { render, staticRenderFns } from "./FormPanel.vue?vue&type=template&id=96222906&scoped=true&"
import script from "./FormPanel.vue?vue&type=script&lang=js&"
export * from "./FormPanel.vue?vue&type=script&lang=js&"
import style0 from "./FormPanel.vue?vue&type=style&index=0&id=96222906&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96222906",
  null
  
)

export default component.exports